<div
  class="form-group"
  [class.required]="isRequired"
  [class.disabled]="isDisabled"
  [formGroup]="parentForm"
  [class.inline]="isInline"
  *ngIf="control"
>
  <mat-checkbox [formControlName]="formControlName" (ngModelChange)="change()">
    {{ title }}
  </mat-checkbox>
</div>
